import { useState } from 'react'
import { optimizationApi } from '../services/optimizationApi'

export type OptimizationExportFormat = 'json' | 'csv' | 'xlsx' | 'pdf'
export type OptimizationPdfTemplate = 'summary' | 'manifest' | 'mass_axle_cg' | 'exceptions' | 'quay'
export type OptimizationPdfPresentation = { locale: 'fr' | 'en'; units: 'metric' | 'imperial' }

export function useOptimizationExport(runId: string) {
  const [isExporting, setIsExporting] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const exportRun = async (format: OptimizationExportFormat, template: OptimizationPdfTemplate = 'summary', presentation?: OptimizationPdfPresentation) => {
    if (!runId || isExporting) return
    setIsExporting(true)
    setError(null)
    try {
      const blob = await optimizationApi.exportRun(runId, format, template, presentation)
      const url = URL.createObjectURL(blob)
      const link = document.createElement('a')
      const safeId = runId.replace(/[^a-zA-Z0-9_-]/g, '_')
      link.href = url
      link.download = `optimization-run-${safeId}${format === 'pdf' ? `-${template}-${presentation?.locale ?? 'fr'}-${presentation?.units ?? 'metric'}` : ''}.${format}`
      document.body.appendChild(link)
      link.click()
      link.remove()
      window.setTimeout(() => URL.revokeObjectURL(url), 1000)
    } catch (cause) {
      setError(cause instanceof Error ? cause.message : 'Export indisponible.')
    } finally {
      setIsExporting(false)
    }
  }

  return { exportRun, isExporting, exportError: error, clearExportError: () => setError(null) }
}
